import { AsyncValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, catchError, map, of } from 'rxjs';
import { setError } from './setError';

export function AsyncValidator(asyncValidate: (value: any) => Observable<boolean>): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
        const asyncError = { async: true };
        if (control.pristine) {
            return of(null);
        }

        return asyncValidate(control.value)
            .pipe(
                map(valid => {
                        const error = valid ? null : asyncError;
                        setError(control, error, 'async');

                        return error;
                    }),
                catchError(() => {
                    setError(control, asyncError, 'async');
                    return of(asyncError);
                }));
    }
}
